<main class="c-main">
  <div class="container-fluid">
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-form-header">
          <div class="wow-form-header__icon"><mat-icon>image</mat-icon></div>
          <mat-card-title>
            Banner
            <span *ngIf="formulario?.value?.id"> — ID {{ formulario.value.id }}</span>
          </mat-card-title>
        </div>

        <p *ngIf="carregando">Carregando...</p>

        <mat-card *ngIf="formulario && !carregando">
          <app-banner-cadastro
            [formulario]="formulario"
            [bannerBase64]="bannerBase64"
            (anexarArquivo)="anexarArquivo($event, 'BANNER')">
          </app-banner-cadastro>

          <div class="wow-form-acoes">
            <button type="button" mat-stroked-button (click)="voltarConsulta()">
              <mat-icon>arrow_back</mat-icon> Voltar
            </button>
            <button type="button" mat-stroked-button (click)="limpar()">
              <mat-icon>clear</mat-icon> Limpar
            </button>
            <button type="button" (click)="salvar()" mat-raised-button color="primary" [disabled]="!formulario.valid">
              <mat-icon>save</mat-icon> Salvar
            </button>
          </div>
        </mat-card>
      </mat-card>
    </div>
  </div>
</main>
